export default __webpack_public_path__ + "static/media/faf-national-edition.64af3188.png";